module.exports = __webpack_public_path__ + "img/case_streaming.8172bc88.png";